__webpack_require__.p = "https://cdn.zeplin.io/assets/webapp/js/";